import React from "react";
import PropTypes from "prop-types";
import memoizeOne from "memoize-one";
import Icon from "../../../common/Icon";
import Slider from "../../../common/Slider";
import Button from "../../../common/Button";
import connectToMedia from "../../Media/connectToMedia";
import S from "../../../styles/components";
import Badge from "../../../common/Badge";

const mapStateToProps = (state) => ({ ...state.media, queries: state.query });

class PrimaryControls extends React.PureComponent {
  static propTypes = {
    currentTime: PropTypes.number,
    duration: PropTypes.number,
    paused: PropTypes.bool,
    bookmarks: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number,
      })
    ),
  };

  static defaultProps = {
    queries: [],
  };

  play = () => {
    const { onPlay } = this.props;
    onPlay();
  };

  pause = () => {
    const { onPause } = this.props;
    onPause();
  };

  skipForward = () => {
    const { onSeek, duration, currentTime } = this.props;
    const skipTime = currentTime + 15000; // currentTime + (duration / 20);
    onSeek({ s: skipTime > duration ? duration : skipTime });
  };

  skipBackward = () => {
    const { onSeek, duration, currentTime } = this.props;
    const skipTime = currentTime - 15000; // currentTime - (duration / 20);
    onSeek({ s: skipTime < 0 ? 0 : skipTime });
  };

  skipToNextHit = (event) => {
    const { queries, currentTime, onSeek } = this.props;
    const hits = this.getHits(queries);
    const hit = hits.find((hit) => hit.s > Math.ceil(currentTime)) || hits[0];

    if (hit) {
      onSeek(hit);
    }
  };

  changeVolume = (value) => {
    const { onVolume } = this.props;

    onVolume(value / 100);
  };

  getHits = memoizeOne((queries) =>
    [].concat(...queries.map((query) => query.hits)).sort((a, b) => a.s - b.s)
  );

  render() {
    const {
      volume,
      paused,
      bookmarks,
      readyState,
      currentTime = 0,
      duration = 0,
      queries,
      agentDetail,
      mediaId,
    } = this.props;

    const loading = readyState < 2;
    const agentExtendedName = `${
      agentDetail?.extended?.agent_first_name
        ? `${agentDetail?.extended?.agent_first_name} `
        : ""
    }${
      agentDetail?.extended?.agent_last_name
        ? agentDetail?.extended?.agent_last_name
        : ""
    }`;
    const agentName = agentDetail?.callDetails?.agent?.fullName;
    const parsedDate = agentDetail?.parsedDate || agentDetail?.startTime;

    const name = agentName || agentExtendedName;
    return (
      <S.PrimaryControls>
        <div>
          <S.PrimaryControlTitle>
            {name ? <span style={{ fontWeight: "400" }}>Agent: </span> : <></>}
            {agentName || agentExtendedName || "No agent details"}
          </S.PrimaryControlTitle>
        </div>
        <div>
          <S.PrimaryControlTitle>
            <span style={{ fontWeight: "400" }}>Media ID: </span>
            {mediaId}
          </S.PrimaryControlTitle>
        </div>
        <div>
          <S.PrimaryControlSubTitle>
            {parsedDate ? `on ${parsedDate}` : ""}
          </S.PrimaryControlSubTitle>
        </div>
      </S.PrimaryControls>
    );
  }
}

export default connectToMedia(mapStateToProps)(PrimaryControls);
